/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Urgency_ContentInputs */

const en_home_urgency_content = /** @type {(inputs: Home_Urgency_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In 2020, experts thought we had more than 35 years until AGI. Recent breakthroughs show we might be almost there. Superintelligence could be one innovation away, so we should tread carefully.`)
};

/**
* | output |
* | --- |
* | "In 2020, experts thought we had more than 35 years until AGI. Recent breakthroughs show we might be almost there. Superintelligence could be one innovation a..." |
*
* @param {Home_Urgency_ContentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_urgency_content = /** @type {((inputs?: Home_Urgency_ContentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Urgency_ContentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_urgency_content(inputs)
});